import { useTranslation } from '@/contexts/i18n-context';
import { SvgProps } from './email';
import styles from './styles.module.css';
import clsx from 'clsx';

export function VideoSvg({ className, ariaLabel }: SvgProps) {
  const { t } = useTranslation();
  return (
    <svg
      role="img"
      aria-label={ariaLabel ?? t('svg.video')}
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      viewBox="0 0 80 80"
      className={clsx(styles.brand, className)}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.4375 21.625C42.9641 21.625 45.1267 22.528 46.9257 24.3337C48.7251 26.139 49.625 28.3096 49.625 30.845C49.6249 33.3802 48.725 35.5505 46.9257 37.3562C45.1267 39.1615 42.9641 40.0641 40.4375 40.0641C37.9109 40.0641 35.7479 39.1615 33.9485 37.3562C32.1496 35.5506 31.2501 33.3802 31.25 30.845C31.25 28.3096 32.1495 26.139 33.9485 24.3337C35.7479 22.528 37.9109 21.625 40.4375 21.625ZM40.4375 25.5762C38.9938 25.5762 37.7579 26.0921 36.7299 27.1237C35.7017 28.1554 35.1875 29.3962 35.1875 30.845C35.1876 32.2936 35.7018 33.5338 36.7299 34.5654C37.758 35.5971 38.9938 36.1129 40.4375 36.1129C41.8812 36.1129 43.117 35.5971 44.1451 34.5654C45.1732 33.5338 45.6874 32.2936 45.6875 30.845C45.6875 29.3962 45.1733 28.1554 44.1451 27.1237C43.1171 26.0921 41.8812 25.5762 40.4375 25.5762Z"
        fill="inherit"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M75 61.335H45.526V68.6434H52.8951V74.125H27.1049V68.6434H34.474V61.335H5V12H75V61.335ZM10.526 55.8525H20.75V54.2683C20.75 52.9785 21.0994 51.7838 21.7976 50.6846C22.4958 49.5854 23.4285 48.7402 24.5961 48.1493C27.1908 46.873 29.8086 45.9157 32.4489 45.2773C35.0887 44.639 37.7517 44.3195 40.4375 44.3195C43.1229 44.3195 45.7858 44.639 48.4261 45.2773C51.066 45.9157 53.6833 46.873 56.2781 48.1493C57.4458 48.7402 58.3791 49.5852 59.0774 50.6846C59.776 51.7838 60.125 52.9786 60.125 54.2683V55.8525H69.474V17.4816H10.526V55.8525ZM40.4375 48.2715C38.0441 48.2715 35.6723 48.559 33.3221 49.1345C30.9715 49.7105 28.6648 50.5572 26.4033 51.6749C25.875 51.962 25.4573 52.3328 25.1498 52.7866C24.8418 53.241 24.6875 53.735 24.6875 54.2683V55.8525H56.1875V54.2683C56.1875 53.735 56.0332 53.241 55.7252 52.7866C55.4172 52.3328 54.9992 51.962 54.4708 51.6749C52.2094 50.5572 49.9031 49.7105 47.5529 49.1345C45.2023 48.559 42.8305 48.2715 40.4375 48.2715Z"
        fill="inherit"
      />
    </svg>
  );
}
